<script>
/* eslint-disable no-console */
import NewForm from "./New";
export default {
  mixins: [NewForm],
  data() {
    return {
      valid: null,
      id: null,
      root: {},
      form: [
        { label: "品種CD", name: "code", required: true, isId: true },
        { label: "品種名", name: "name", required: true },
        { label: "品種名英文", name: "englishName" },
        { label: "機種名称", name: "model" }
      ]
    };
  },
  methods: {
    returnToList() {
      this.$router.push({
        name: "M0230"
      });
    },
    remove() {
      this.$http
        .delete(`/products/${this.root.code}`)
        .then(res => {
          return res.data;
        })
        .then(() => {
          this.returnToList();
        })
        .catch();
    },
    save() {
      this.$http
        .put(`/products/${this.id}`, { ...this.root })
        .then(res => {
          return res.data;
        })
        .then(() => {
          this.returnToList();
        })
        .catch();
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.$http.get(`/products/${this.id}`)
      .then(res => {
        this.root = { ...res.data };
      })
      .catch(() => {});
  }
};
</script>
